import { useApiErrorSnackbar } from '../common/useApiErrorSnackbar';
import useWalletsApi from '~/composables/api/useWalletsApi';

export const useWalletStatement = () => {
  const { $i18n } = useNuxtApp();
  const { locale } = $i18n;
  const { notifyApiError } = useApiErrorSnackbar();
  const { getWalletStatement } = useWalletsApi();
  const { dateFormat } = useDataGrid();

  const walletStatement = ref();
  const isLoadingStatement = ref(true);

  const loadWalletStatement = async (dateRange: Array<string>, walletIntId?: number) => {
    walletStatement.value = undefined;
    isLoadingStatement.value = true;

    try {
      const startDate = getDate(dateRange[0], dateFormat.value, locale.value).startOf('month');
      const endDate = getDate(dateRange[1], dateFormat.value, locale.value)
        .add(1, 'day')
        .startOf('day');

      let params = `?startDate=${startDate.unix()}&endDate=${endDate.unix()}`;
      if (walletIntId != null) {
        params += `&walletIntId=${walletIntId}`;
      }

      const statement = await getWalletStatement(params);
      walletStatement.value = statement;
      return statement;
    } catch (error: unknown) {
      notifyApiError(error);
    } finally {
      isLoadingStatement.value = false;
    }
  };

  return { walletStatement, loadWalletStatement, isLoadingStatement };
};
